import React from "react";
import { useSelector } from 'react-redux';
import './FieldSensors.scss';
import {getStatusColor} from "../helpers/helpers";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const FieldSensors = props => {
    const { t } = useSelector(selector);
    const { field, backMethod } = props;

    return (
        <div className='fieldSensors'>
            <div className='fieldSensorsHeader'>
                <div className='fieldSensorsTitle'>
                    {field.name}
                </div>
                <button
                    className='fieldSensorsBackButton'
                    onClick={backMethod}
                >
                    <span className='material-icons fieldSensorsBackButtonIcon'>
                        arrow_back
                    </span>
                    {t.gettext('Fields')}
                </button>
            </div>
            <ul className='fieldSensorsList'>
                {field.sensors.map(sensor => (
                    <li key={sensor.id}
                        className='fieldSensorsListItem'
                    >
                        <div
                            className='fieldSensorsListItemStatusColorBar'
                            style={{background: getStatusColor(sensor.temperatureStatus)}}
                        />
                        <div className='fieldSensorDetails'>
                            <div className='fieldSensorDetail'>
                                {t.gettext('Sensor Name') + ' : '}
                                <span>{sensor.name}</span>
                            </div>
                            <div className='fieldSensorDetail'>
                                {t.gettext('Lora Identifier') + ' : '}
                                <span>{sensor.loraIdentifier}</span>
                            </div>
                            <div className='fieldSensorDetail'>
                                {t.gettext('Measurement Time') + ' : '}
                                <span>{sensor.measurements[0].dateTimeCreated.replace('T', ' ')}</span>
                            </div>
                            <div className='fieldSensorDetail'>
                                {t.gettext('Temperature') + ' : '}
                                <span>{sensor.temperature + ' '} &#8451;</span>
                            </div>
                            <div className='fieldSensorDetail'>
                                {t.gettext('Humidity') + ' : '}
                                <span>{sensor.measurements[0].humidity + ' '} %</span>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FieldSensors;
